"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NcConnectionMgrv2;
    }
});
const _common = require("@nestjs/common");
const _ncconfig = require("~/utils/nc-config");
const _SqlClientFactory = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/SqlClientFactory"));
const _CustomKnex = require("~/db/CustomKnex");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let NcConnectionMgrv2 = class NcConnectionMgrv2 {
    static async destroyAll() {
        for(const baseId in this.connectionRefs){
            for(const sourceId in this.connectionRefs[baseId]){
                await this.connectionRefs[baseId][sourceId].destroy();
            }
        }
    }
    static async deleteAwait(source) {
        var _this_connectionRefs_source_base_id, _this_connectionRefs;
        // todo: ignore meta bases
        if ((_this_connectionRefs = this.connectionRefs) == null ? void 0 : (_this_connectionRefs_source_base_id = _this_connectionRefs[source.base_id]) == null ? void 0 : _this_connectionRefs_source_base_id[source.id]) {
            try {
                var _this_connectionRefs_source_base_id1, _this_connectionRefs1, _this_connectionRefs2;
                const conn = (_this_connectionRefs1 = this.connectionRefs) == null ? void 0 : (_this_connectionRefs_source_base_id1 = _this_connectionRefs1[source.base_id]) == null ? void 0 : _this_connectionRefs_source_base_id1[source.id];
                await conn.destroy();
                (_this_connectionRefs2 = this.connectionRefs) == null ? true : delete _this_connectionRefs2[source.base_id][source.id];
            } catch (e) {
                this.logger.error({
                    error: e,
                    details: 'Error deleting connection ref'
                });
            }
        }
    }
    static async deleteConnectionRef(sourceId) {
        let deleted = false;
        for(const baseId in this.connectionRefs){
            try {
                if (this.connectionRefs[baseId][sourceId]) {
                    await this.connectionRefs[baseId][sourceId].destroy();
                    delete this.connectionRefs[baseId][sourceId];
                    deleted = true;
                }
            } catch (e) {
                this.logger.error({
                    error: e,
                    details: 'Error deleting connection ref'
                });
            }
        }
        return deleted;
    }
    static async get(source) {
        var _this_connectionRefs_source_base_id, _this_connectionRefs, _this_connectionRefs1;
        if (source.isMeta()) return _Noco.default.ncMeta.knex;
        if ((_this_connectionRefs = this.connectionRefs) == null ? void 0 : (_this_connectionRefs_source_base_id = _this_connectionRefs[source.base_id]) == null ? void 0 : _this_connectionRefs_source_base_id[source.id]) {
            var _this_connectionRefs_source_base_id1, _this_connectionRefs2;
            return (_this_connectionRefs2 = this.connectionRefs) == null ? void 0 : (_this_connectionRefs_source_base_id1 = _this_connectionRefs2[source.base_id]) == null ? void 0 : _this_connectionRefs_source_base_id1[source.id];
        }
        this.connectionRefs[source.base_id] = ((_this_connectionRefs1 = this.connectionRefs) == null ? void 0 : _this_connectionRefs1[source.base_id]) || {};
        const connectionConfig = await source.getConnectionConfig();
        this.connectionRefs[source.base_id][source.id] = (0, _CustomKnex.XKnex)(_extends({}, _ncconfig.defaultConnectionOptions, connectionConfig, {
            connection: _extends({}, _ncconfig.defaultConnectionConfig, connectionConfig.connection, {
                typeCast (field, next) {
                    const res = next();
                    // mysql - convert all other buffer values to hex string
                    // if `bit` datatype then convert it to integer number
                    if (res && res instanceof Buffer) {
                        const hex = [
                            ...res
                        ].map((v)=>('00' + v.toString(16)).slice(-2)).join('');
                        if (field.type == 'BIT') {
                            return parseInt(hex, 16);
                        }
                        return hex;
                    }
                    // mysql `decimal` datatype returns value as string, convert it to float number
                    if (field.type == 'NEWDECIMAL') {
                        return res && parseFloat(res);
                    }
                    return res;
                }
            })
        }));
        return this.connectionRefs[source.base_id][source.id];
    }
    static async getSqlClient(source, _knex = null) {
        const knex = _knex || await this.get(source);
        return _SqlClientFactory.default.create(_extends({
            knex
        }, await source.getConnectionConfig()));
    }
    static async getDataConfig() {
        var _Noco_getConfig_meta, _Noco_getConfig;
        return (_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : _Noco_getConfig_meta.db;
    }
};
NcConnectionMgrv2.logger = new _common.Logger('NcConnectionMgrv2');
NcConnectionMgrv2.connectionRefs = {};
